import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import TopBannerList from "../../components/Tables/TopBannerList";
import BottomBannerList from "../../components/Tables/BottomBannerList";

class TableBottomBanner extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Table Normal"
              Breadcrumb={[
                { name: "Table", navigate: "" },
                { name: "Table Normal", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              {/* <BasicTable /> */}
              {/* <StripedRows /> */}
              {/* <BorderedTable /> */}
              <BottomBannerList />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({});

export default connect(mapStateToProps, {})(TableBottomBanner);
